export default __webpack_public_path__ + "static/media/BOLSITA.b1652da4.png";